import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {HomePageRouting} from '@modules/home/tabs/home-page/home-page.routing';
import {HomePageComponent} from '@modules/home/tabs/home-page/pages/home-page/home-page.component';
import {VideosLivestreamComponent} from './components/videos-livestream/videos-livestream.component';
import {LibSectionModule} from '@lib-modules/section/lib-section.module';
import {SharedWidgetsModule} from '@app/shared/modules/shared-widgets/shared-widgets.module';
import {SharedSpecialsModule} from '@app/shared/modules/shared-specials/shared-specials.module';
import {LibAdsModule} from '@lib-modules/ads/lib-ads.module';
import {LibBannersModule} from '@lib-modules/banners/lib-banners.module';
import {SharedBannersModule} from '@app/shared/modules/shared-banners/shared-banners.module';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {PickerModule} from '@lib-modules/picker/picker.module';
import {LibAdCampaignModule} from '@components/ad-campaign/lib-ad-campaign.module';

@NgModule({
  imports: [
    CommonModule,
    HomePageRouting,
    SharedWidgetsModule,
    SharedSpecialsModule,
    SharedBannersModule,
    LibSectionModule,
    LibAdsModule,
    LibBannersModule,
    MatProgressSpinnerModule,
    PickerModule,
    LibAdCampaignModule,
  ],
  declarations: [
    HomePageComponent,
    VideosLivestreamComponent,
  ],
  exports: [],
  providers: []
})
export class HomePageModule {
}
